import { Button } from "@/components/base/Button.tsx";
import { useNavigate } from "react-router-dom";
import { usePaginatedData } from "@/hooks/usePaginatedData.ts";
import { EyeIcon } from "lucide-react";
import { Appointment } from "@/models";
import { DataTable } from "@/components/datatables/DataTable.tsx";
import { appointmentsColumns } from "@/components/datatables/appointments/Appointments.Columns.tsx";
import { appointment } from "@/repositories/appointment.ts";

export const AppointmentsTable = () => {
  const navigate = useNavigate();
  const { data, rowCount, pagination, setPagination } = usePaginatedData(
    appointment.search
  );

  const actions = (appointment: Appointment) => {
    return [
      <Button onClick={() => navigate(appointment.id)} variant="secondary">
        <EyeIcon />
      </Button>,
    ];
  };

  return (
    <DataTable
      data={data}
      columns={appointmentsColumns({ actions: actions })}
      pagination={pagination}
      setPagination={setPagination}
      rowCount={rowCount}
    />
  );
};
